import script from "./ProgressBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProgressBar.vue?vue&type=script&lang=ts&setup=true"

import "./ProgressBar.vue?vue&type=style&index=0&id=87d08242&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87d08242"]])

export default __exports__